module.exports = __webpack_public_path__ + "img/water-droplet-10.c3f538da.png";